@if (label) {
  <label>{{ label }}</label>
}

@if (!file?.link) {
  <button class="btn btn-primary" (click)="onFileSelectClicked()">Select File</button>
}

@if (file?.link) {
  <div class="file-preview">
    @switch (file.type) {
      @case ('IMAGE') {
        <div class="image-container">
          <img [src]="file.link" [alt]="file.name">
          <div class="edit-overlay">
            <button class="btn btn-secondary-icon cl-selected-color bg-white" (click)="fileEditClicked()">
              <span class="cm-icon cm-icon-edit" aria-hidden="true"></span>
            </button>
            @if (isRemoveAllowed) {
              <button class="btn btn-secondary-icon cl-error-color bg-white remove-button"
                (click)="fileRemoveClicked()">
                <span class="cm-icon cm-icon-close" aria-hidden="true"></span>
              </button>
            }
          </div>
        </div>
      }
      @case ('PDF') {
        <div class="row">
          <div class="col-10 truncate">
            <span class="cm-icon cm-icon-pdf" aria-hidden="true"></span>
            <span class="file-name">
              {{ file.name }}
            </span>
          </div>
          <div class="col-2 text-right">
            <span class="cm-icon cm-icon-close remove-file-pdf" aria-hidden="true"
            (click)="fileRemoveClicked()"></span>
          </div>
        </div>
      }
    }
  </div>
}
